import type { GroupInfo, IsContactEnum, User } from '../sdk';
import { formatUser } from '../utils';
import { AbstractApi } from './Api';

interface PullContactsFromCloudParams {
  cloud_data: string;
  local_device: string;
}

export class ContactsApi extends AbstractApi {
  contactsAdd(user_id: string, abortSignal?: AbortSignal) {
    return this.client.invoke('contactsAdd', [user_id], abortSignal);
  }
  contactsDelete(user_id: string, abortSignal?: AbortSignal) {
    return this.client.invoke('contactsDelete', [user_id], abortSignal) as unknown as Promise<{
      category: IsContactEnum;
    }>;
  }
  contactsQuery(user_id: string, abortSignal?: AbortSignal) {
    return this.client.invoke('contactsQuery', [user_id], abortSignal) as unknown as Promise<{
      category: IsContactEnum;
    }>;
  }
  async contactsSearchByKeyInLocal(key: string, abortSignal?: AbortSignal) {
    const { users } = (await this.client.invoke(
      'contactsSearchByKeyInLocal',
      [key],
      abortSignal
    )) as unknown as { users: User[] };
    return { users: users?.map((user) => formatUser(user)) ?? [] };
  }
  async contactsSearchGroupByKeyInLocal(key: string, abortSignal?: AbortSignal) {
    const groups: Array<GroupInfo & { members_update_at: number }> = await this.client
      .invoke('contactsSearchByKeyInLocal', [key], abortSignal)
      .then((res: any) => res.groups);
    return groups ?? [];
  }
  async contactsSearchByBeyInGlobal(key: string, abortSignal?: AbortSignal) {
    const users = (await this.client.invoke(
      'contactsSearchByBeyInGlobal',
      [key],
      abortSignal
    )) as unknown as User[];
    return users?.map((user) => formatUser(user)) ?? [];
  }
  async setRemarkName(
    user_id: string,
    first_name: string,
    last_name: string,
    abortSignal?: AbortSignal
  ) {
    await this.client.invoke('setRemarkName', [user_id, first_name, last_name], abortSignal);

    const data = {
      remark_first_name: first_name,
      remark_last_name: last_name,
    };
    await this.client.Api.user.dispatchSetUserData(user_id, data);
    await this.client.Api.user.dispatchSetUserProfile(user_id, data);
  }
  pullContactsFromCloud({ cloud_data, local_device }: PullContactsFromCloudParams) {
    return this.client.invoke('pullContactsFromCloud', [cloud_data, local_device]);
  }
  removeGroup(gid: string, abortSignal?: AbortSignal) {
    return this.client.invoke('removeGroupFromContacts', [gid], abortSignal);
  }
  queryGroup(gid: string, abortSignal?: AbortSignal) {
    return this.client.invoke('queryGroup', [gid], abortSignal);
  }
  addGroup(gid: string, abortSignal?: AbortSignal) {
    return this.client.invoke('addGroupToContacts', [gid], abortSignal);
  }
  getSessionsById(chat_ids: string[], abortSignal?: AbortSignal) {
    return this.client.invoke('getSessionsById', [chat_ids], abortSignal);
  }
}
